import ld1 from '../../assets/ld1.jpg';
import ld2 from '../../assets/ld2.jpg';
import ld3 from '../../assets/ld3.jpg';
import ld4 from '../../assets/ld4.jpg';

const news = [
  {
    image: ld1,
    title: "GeoGlobalGate LTD — NCTS T1 Transit Services in Georgia",
    excerpt: "We provide fast and reliable NCTS T1 transit declaration services across Georgia's major border crossings.",
    date: "2025",
    likes: 48,
    comments: 7,
    link: "https://www.linkedin.com/posts/geoglobalgate-ltd_geoglobalgate-ltd-activity-7457800300712697856-j76Z",
  },
  {
    image: ld2,
    title: "Logistics | Transport | Freight",
    excerpt: "Our team ensures every shipment moves efficiently across borders — with full documentation, real-time support and seamless coordination.",
    date: "2025",
    likes: 63,
    comments: 12,
    link: "https://www.linkedin.com/posts/geoglobalgate-ltd_logistics-transport-freight-activity-7457378485548974082-1J8h",
  },
  {
    image: ld3,
    title: "What Really Happens Behind a Smooth Transit",
    excerpt: "A smooth transit doesn't happen by accident. It takes precise documentation, coordination with customs authorities, and a team that knows every step of the process.",
    date: "2025",
    likes: 35,
    comments: 5,
    link: "https://www.linkedin.com/posts/geoglobalgate-ltd_what-really-happens-behind-a-smooth-transit-activity-7456294698194800640-lDYJ",
  },
  {
    image: ld4,
    title: "Logistics Delays Don't Start on the Road",
    excerpt: "Most logistics delays begin long before the truck moves — in missing documents, incorrect declarations, or miscommunication. We help you avoid them from the start.",
    date: "2025",
    likes: 91,
    comments: 18,
    link: "https://www.linkedin.com/posts/geoglobalgate-ltd_logistics-delays-dont-start-on-the-road-activity-7455257363705606144-JAIk",
  },
];

export default news;
